// The invite to SermonBuild 2.0 (SermonBuildNew PLAN-014).
//
// Who sees it is a build-time switch, so each wave is one env change and a
// redeploy, with no table and no migration:
//
//   VITE_V2_INVITE=off     nobody (also the answer for unset or any typo)
//   VITE_V2_INVITE=admins  admin_users only, to check it on the live site
//   VITE_V2_INVITE=all     every signed-in pastor
//
// Pastors who already have a sermon in 2.0 never see it; that check lives in
// the banner, because it needs the database.

export const V2_APP_URL = 'https://beta.sermonbuild.com';

export type V2InviteAudience = 'off' | 'admins' | 'all';

/** Fails closed: only the exact lowercase words open it. */
export function v2InviteAudience(raw: string | undefined = import.meta.env.VITE_V2_INVITE): V2InviteAudience {
  return raw === 'admins' || raw === 'all' ? raw : 'off';
}

export function v2InviteAllowed(audience: V2InviteAudience, isAdmin: boolean): boolean {
  return audience === 'all' || (audience === 'admins' && isAdmin);
}

/** Not over the editor: the invite must never interrupt someone writing. */
export function v2InviteShownOn(pathname: string): boolean {
  return !pathname.startsWith('/dashboard/editor');
}

const dismissedKey = (userId: string) => `sb2-invite-dismissed:${userId}`;

// Storage can throw (private windows, blocked site data). Either way the
// answer degrades to "not dismissed", which only means the banner shows again.
export function isV2InviteDismissed(userId: string): boolean {
  try {
    return localStorage.getItem(dismissedKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function dismissV2Invite(userId: string): void {
  try {
    localStorage.setItem(dismissedKey(userId), '1');
  } catch {
    // Dismissed for this visit only; see above.
  }
}
